import { EnvironmentProviders, makeEnvironmentProviders } from '@angular/core';

import { provideApi } from './api/api.providers';
import { provideI18n } from './i18n/i18n.providers';
import { provideStorage } from './storage/storage.providers';
import { provideInterceptors } from './interceptors/interceptors.providers';

// Same registration order as the former CoreModule imports (ApiModule, I18nModule, StorageModule,
// InterceptorsModule)
export function provideCore(): EnvironmentProviders {
  return makeEnvironmentProviders([
    provideApi(),
    provideI18n(),
    provideStorage(),
    provideInterceptors(),
  ]);
}
